import React, { ChangeEvent } from "react";
import { HiCloudArrowUp } from "react-icons/hi2";

// List of countries for the dropdown
export const countries = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cabo Verde",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Fiji",
  "Finland",
  "France",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Grenada",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Korea, North",
  "Korea, South",
  "Kosovo",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "North Macedonia",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestine",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican City",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];

interface SelectFieldProps {
  value: string;
  onChange: (event: ChangeEvent<HTMLSelectElement>) => void;
  disabled: boolean;
}

interface TextFieldProps {
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  disabled: boolean;
}

interface ImageFieldProps {
  value: File | null;
  previewUrl: string | null;
  onChange: (file: File | null) => void;
  disabled: boolean;
}

// Shared form field components
export const GenderField: React.FC<SelectFieldProps> = ({
  value,
  onChange,
  disabled,
}) => (
  <div className="form-group">
    <label className="form-label" htmlFor="gender">
      Gender *
    </label>
    <select
      className="form-select"
      id="gender"
      value={value}
      onChange={onChange}
      disabled={disabled}
      required
    >
      <option value="">Select Gender</option>
      <option value="Male">Male</option>
      <option value="Female">Female</option>
    </select>
  </div>
);

export const RoleField: React.FC<SelectFieldProps> = ({
  value,
  onChange,
  disabled,
}) => (
  <div className="form-group">
    <label className="form-label" htmlFor="role">
      Role *
    </label>
    <select
      className="form-select"
      id="role"
      value={value}
      onChange={onChange}
      disabled={disabled}
      required
    >
      <option value="">Select Role</option>
      <option value="Athlete">Athlete</option>
      <option value="Coach">Coach</option>
    </select>
  </div>
);

export const CountryField: React.FC<SelectFieldProps> = ({
  value,
  onChange,
  disabled,
}) => (
  <div className="form-group">
    <label className="form-label" htmlFor="country">
      Country *
    </label>
    <select
      className="form-select"
      id="country"
      value={value}
      onChange={onChange}
      disabled={disabled}
      required
    >
      <option value="">Select Country</option>
      {countries.map((countryName) => (
        <option key={countryName} value={countryName}>
          {countryName}
        </option>
      ))}
    </select>
  </div>
);

export const ReasonField: React.FC<SelectFieldProps> = ({
  value,
  onChange,
  disabled,
}) => (
  <div className="form-group">
    <label className="form-label" htmlFor="reason">
      Reason for Joining *
    </label>
    <select
      className="form-select"
      id="reason"
      value={value}
      onChange={onChange}
      disabled={disabled}
      required
    >
      <option value="">Select Reason</option>
      <option value="I want to train like an Athlete">
        I want to train like an Athlete
      </option>
      <option value="Better Health, Training & Wellness Monitoring">
        Better Health, Training & Wellness Monitoring
      </option>
      <option value="Just curious">Just curious</option>
      <option value="I watch Tori on TikTok">I watch Tori on TikTok</option>
      <option value="I want to learn how I can optimise my performance">
        I want to learn how I can optimise my performance
      </option>
      <option value="Other">Other</option>
    </select>
  </div>
);

export const NameField: React.FC<TextFieldProps> = ({
  value,
  onChange,
  disabled,
}) => (
  <div className="form-group">
    <label className="form-label" htmlFor="name">
      First Name *
    </label>
    <input
      className="form-input"
      id="name"
      name="name"
      type="text"
      autoComplete="given-name"
      required
      value={value}
      onChange={onChange}
      disabled={disabled}
      placeholder="Enter your first name"
    />
  </div>
);

export const SurnameField: React.FC<TextFieldProps> = ({
  value,
  onChange,
  disabled,
}) => (
  <div className="form-group">
    <label className="form-label" htmlFor="surname">
      Last Name *
    </label>
    <input
      className="form-input"
      id="surname"
      name="surname"
      type="text"
      autoComplete="family-name"
      required
      value={value}
      onChange={onChange}
      disabled={disabled}
      placeholder="Enter your last name"
    />
  </div>
);

export const DateOfBirthField: React.FC<TextFieldProps> = ({
  value,
  onChange,
  disabled,
}) => (
  <div className="form-group">
    <label className="form-label" htmlFor="dob">
      Date of Birth *
    </label>
    <input
      className="form-input"
      id="dob"
      name="dob"
      type="date"
      required
      value={value}
      onChange={onChange}
      disabled={disabled}
    />
    <p className="text-xs text-base-content/60 mt-1">Format: DD/MM/YYYY</p>
  </div>
);

export const ImageField: React.FC<ImageFieldProps> = ({
  value,
  previewUrl,
  onChange,
  disabled,
}) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0] || null;
    onChange(file);
  };

  return (
    <div className="w-full text-center">
      {previewUrl && (
        <div className="mb-4">
          <img
            src={previewUrl}
            alt="Profile preview"
            className="mx-auto w-48 h-48 rounded-full object-cover border-4 border-base-300"
          />
        </div>
      )}
      <div className="relative">
        <input
          type="file"
          accept="image/*"
          onChange={handleChange}
          disabled={disabled}
          className="sr-only rounded-lg"
          id="profile-image-input"
        />
        <label
          htmlFor="profile-image-input"
          className={`0 p-3 rounded-xl px-4 border-2 w-full border-base-300 inline-flex items-center gap-2 cursor-pointer ${
            disabled ? "opacity-50 cursor-not-allowed" : ""
          }`}
        >
          <HiCloudArrowUp className="text-lg text-base-content/60" />
          {value ? "Change Profile Picture" : "Upload Profile Picture"}
        </label>
      </div>
    </div>
  );
};
